module.exports = __webpack_public_path__ + "img/IT0002927002914.404eda9f.png";